export default __webpack_public_path__ + "static/media/image02.8f9a63d8.png";